module.exports = __webpack_public_path__ + "img/user-dummy.1f9568b7.png";